import { Palette } from '@mui/material';
import { FontSize } from '@store/types/UserStoreSlice.type';
import { getTypographyVariants } from '@theme/styleOverrides/typography';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const MuiBadge = ({ palette, fontSize }: { palette: Palette; fontSize: FontSize }) => ({
  styleOverrides: {
    root: {
      '& .MuiBadge-badge': {
        ...getTypographyVariants(fontSize).tableHeader,
        fontWeight: getTypographyVariants(fontSize).fontWeightBold,
        fontFamily: 'Proxima Nova',
        padding: '8px 6px',
        height: '14px',
        minWidth: 'auto',
        width: 'auto',
        top: 'auto',
        right: 'auto',
      },
    },
  },
});
